import { useEffect, useState } from "@wordpress/element";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Flatpickr from "react-flatpickr";
import MenuItem from "@mui/material/MenuItem";
import find from "lodash/find";
import { Button } from "@wordpress/components";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { TextField, NumberFormat, SelectField } from "vino/core/forms";
import { setEventInformation } from "store/vino/eventBookingSlice";
import { EventInformationSchema, eventInformationState } from "../models";
import { checkDayIsAvailable, getTimeSlotsByDay } from "./helper";
import "flatpickr/dist/themes/material_green.css";

function EventInformation({ onNext }) {
	const [timeSlots, setTimeSlots] = useState([]);
	const dispatch = useDispatch();
	const eventInformation = useSelector(
		({ vino }) => vino.eventBooking.eventInformation
	);
	const eventPackage = useSelector(({ vino }) => vino.eventBooking.package);
	const eventSlots = useSelector(({ vino }) => vino.eventBooking.eventSlots);

	const methods = useForm({
		mode: "onChange",
		defaultValues: eventInformationState,
		resolver: yupResolver(EventInformationSchema),
	});

	const { handleSubmit, reset, setValue, watch } = methods;
	const eventDate = watch("eventDate");
	const eventTime = watch("eventTime");

	useEffect(() => {
		if (eventInformation) {
			const timeSlots = getTimeSlotsByDay(
				eventInformation.eventDate,
				eventSlots
			);
			setTimeSlots(timeSlots);
			reset(eventInformation);
		}
	}, [reset, eventInformation]);

	useEffect(() => {
		if (eventDate) {
			const timeSlots = getTimeSlotsByDay(eventDate, eventSlots);
			setTimeSlots(timeSlots);
		}
	}, [eventDate]);

	useEffect(() => {
		if (eventTime) {
			const slot = find(timeSlots, { id: eventTime });
			setValue("slot", slot);
		}
	}, [eventTime]);

	const handleDayAvailable = (date) => {
		return !checkDayIsAvailable(date, eventSlots, eventPackage);
	};

	const handleDateChange = ([date]) => {
		setValue("eventDate", date);
	};

	const onSubmit = (model) => {
		dispatch(setEventInformation(model));
		onNext();
	};

	if (!eventPackage) {
		return null;
	}

	return (
		<Paper className="w-full rounded-20 shadow">
			<FormProvider {...methods}>
				<form
					className="flex flex-col w-full"
					noValidate
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="flex items-center justify-between p-20">
						<Typography className="text-16 font-medium">
							Event Schedule
						</Typography>
					</div>

					<div className="flex flex-col justify-center w-full px-20">
						<div className="mb-16 w-full flex">
							<div className="mr-20">
								<Flatpickr
									value={eventDate}
									options={{
										inline: true,
										enableTime: false,
										disable: [handleDayAvailable],
									}}
									onChange={handleDateChange}
								/>
							</div>
							<div className="ml-30 flex flex-col justify-items-center">
								<div className="mb-16">
									<SelectField name="eventTime" label="Time" required fullWidth>
										<MenuItem value="">Select</MenuItem>
										{timeSlots.map((timeSlot, index) => (
											<MenuItem value={timeSlot.id} key={index}>
												{timeSlot.start} - {timeSlot.end}
											</MenuItem>
										))}
									</SelectField>
								</div>
								<div className="mb-16">
									<TextField
										name="numberOfGuests"
										label="# Guests"
										required
										InputProps={{
											inputComponent: NumberFormat,
										}}
									/>
								</div>
							</div>
						</div>

						<div className="flex justify-end w-full mb-20">
							<Button type="submit">
								Next <i className="fa-solid fa-angle-right"></i>
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
}
export default EventInformation;
